import cn from 'classnames';

import { IConDefaultType } from '../types';

interface INewPageIconProps extends IConDefaultType {}

export default function NewPageIcon({ color, className, size = 24, rotate, flip, style }: INewPageIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16 17H8C7.73478 17 7.48043 16.8946 7.29289 16.7071C7.10536 16.5196 7 16.2652 7 16C7 15.7348 7.10536 15.4804 7.29289 15.2929C7.48043 15.1054 7.73478 15 8 15H16C16.2652 15 16.5196 15.1054 16.7071 15.2929C16.8946 15.4804 17 15.7348 17 16C17 16.2652 16.8946 16.5196 16.7071 16.7071C16.5196 16.8946 16.2652 17 16 17Z"
          fill={color || '#8A8A8A'}
        />
        <path
          d="M13.0002 13H7.93018C7.66496 13 7.4106 12.8946 7.22307 12.7071C7.03553 12.5196 6.93018 12.2652 6.93018 12C6.93018 11.7348 7.03553 11.4804 7.22307 11.2929C7.4106 11.1054 7.66496 11 7.93018 11H13.0002C13.2654 11 13.5197 11.1054 13.7073 11.2929C13.8948 11.4804 14.0002 11.7348 14.0002 12C14.0002 12.1313 13.9743 12.2614 13.9241 12.3827C13.8738 12.504 13.8001 12.6142 13.7073 12.7071C13.6144 12.8 13.5042 12.8736 13.3829 12.9239C13.2615 12.9741 13.1315 13 13.0002 13Z"
          fill={color || '#8A8A8A'}
        />
        <path
          d="M20.24 6.82999L17.17 3.75999C16.6157 3.19955 15.9552 2.75524 15.2272 2.45304C14.4992 2.15084 13.7182 1.99682 12.93 1.99999H8C6.4087 1.99999 4.88258 2.63213 3.75736 3.75735C2.63214 4.88256 2 6.40869 2 7.99999V16C2 17.5913 2.63214 19.1174 3.75736 20.2426C4.88258 21.3678 6.4087 22 8 22H16C17.5913 22 19.1174 21.3678 20.2426 20.2426C21.3679 19.1174 22 17.5913 22 16V11.07C21.9986 9.47922 21.3655 7.95412 20.24 6.82999ZM18.65 8.05999C18.4357 8.01972 18.2181 7.99963 18 7.99999H17C16.7348 7.99999 16.4804 7.89463 16.2929 7.70709C16.1054 7.51956 16 7.2652 16 6.99999V5.99999C16.0004 5.78192 15.9803 5.5643 15.94 5.34999L18.65 8.05999ZM20 16C20 17.0609 19.5786 18.0783 18.8284 18.8284C18.0783 19.5786 17.0609 20 16 20H8C6.93913 20 5.92172 19.5786 5.17157 18.8284C4.42143 18.0783 4 17.0609 4 16V7.99999C4 6.93912 4.42143 5.9217 5.17157 5.17156C5.92172 4.42141 6.93913 3.99999 8 3.99999H12C12.5304 3.99999 13.0391 4.2107 13.4142 4.58577C13.7893 4.96085 14 5.46955 14 5.99999V6.99999C14 7.79564 14.3161 8.5587 14.8787 9.12131C15.4413 9.68392 16.2044 9.99999 17 9.99999H18C18.5304 9.99999 19.0391 10.2107 19.4142 10.5858C19.7893 10.9608 20 11.4696 20 12V16Z"
          fill={color || '#8A8A8A'}
        />
      </svg>
    </i>
  );
}
